(function () {
	'use strict';

    angular.module("imApp").factory("consignmentPlansDeliveryLabourService", ['$ihttp', function ($ihttp) {
		let service = {
            listLabours: function (parms) {
                return $ihttp.post({
                    method: 1790,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
